<template>
    <div class="product-kits-modal-card">
        <a
            class="product-kits-modal-card__image"
            :href="result?.detailPage"
        >
            <DefImg :result="result.picture || result?.morePhotos?.[0]" />
        </a>

        <div class="product-kits-modal-card__description">
            <p class="product-kits-modal-card__art">
                арт. {{ result.article }}
            </p>
            <a :href="result?.detailPage" class="product-kits-modal-card__name">
                {{ result.type }}
            </a>
        </div>
        <SkuKit :result="result" @changeSKU="$emit('changeSKU', $event)" />
        <div class="product-kits-modal-card__prices">
            <p class="def-price">
                {{ price.printPrice }}
            </p>
        </div>
    </div>
</template>

<script>
import DefImg from "../../../def/DefImg/DefImg";

export default {
    name: 'ProductKitsModalCard',
    props: ['result'],
    components: {
        DefImg,
    },
    computed: {
        price() {
            return this.result.price;
        }
    }
}
</script>

<style lang="scss" scoped>
.product-kits-modal-card{
    display: grid;
    grid-template-columns: 80px 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 8px;
    align-items: flex-start;
    grid-template-areas:
        "image description"
        "image sku"
        "image prices"
    ;
    //padding: 16px;
    @include point-md{
        grid-template-columns: 80px 1fr 120px 120px;
        grid-template-areas: "image description sku prices";
        //grid-column-gap: 16px;
        align-items: center;
    }
    @include point-lg{
        grid-template-columns: 88px 1fr 160px 142px;
    }
    &__image{
        grid-area: image;
        padding: 15px;
        @include point-md{
            padding: 16px;
        }
    }
    &__description{
        grid-area: description;
    }
    &__art{
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        color: #757575;
        margin-bottom: 4px;
        @include point-md{
            font-size: 14px;
            line-height: 100%;
        }
    }
    &__name{
        font-weight: 500;
        font-size: 14px;
        line-height: 115%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        margin-bottom: 8px;
        @include point-md{
            margin-bottom: 0;
        }
        @include point-lg{
            font-size: 16px;
            line-height: 115%;
        }
    }
    &__prices{
        margin-top: 8px;
        @include point-md{
            text-align: end;
            margin-top: 0;
        }
    }
    .def-price{
        font-size: 16px;
        line-height: 110%;
        grid-area: prices;
    }
    :deep{
        .sku-selects{
            margin-bottom: 0;
            grid-area: sku;
        }
    }
}
</style>